import React, { Component } from 'react';
import injectSheet from 'react-jss';
import SVGInline from 'react-svg-inline';
import values from 'lodash/values';
import keys from 'lodash/keys';
import styles from './style';
import defaultProps from './defaultProps';
import arrowRightIcon from '../../images/right-arrow.svg';
import {
    getIndexesInRange,
    renderHeaderCells,
    renderHeaderActions,
    sortTable
} from './helpers';
import Rows from './Rows';
import { Typography, theme } from '@hiver/hiver-ui-kit';
import {FixedSizeList} from 'react-window';
import memoizeOne from 'memoize-one'; 

const ROW_HEIGHT = 53;

const memoizedSortTable = memoizeOne(sortTable);

class UsersTable extends Component {

    static defaultProps = defaultProps;

    constructor(props) {
        super(props);
        this.state = {
            selected: {},
            sortKey: 'id',
            sortOrder: -1,
            lastOperationIdx: -1
        };
    }

    componentDidUpdate(prevProps) {
      if (this.props.data.length !== prevProps.data.length) {
        this.setState({ selected: {} });
      }
    }
    getSelectedLength = () => keys(this.state.selected).length;

    isChecked = (idx) => this.state.selected.hasOwnProperty(idx);

    isAllSelected = () => {
        return this.props.data.length > 0 &&
            this.getSelectedLength() === this.props.data.length;
    };

    handleSort = (item) =>
        this.setState(({ sortOrder, sortKey }) => ({
            sortKey: item.accessor,
            sortOrder: sortKey === item.accessor ? -sortOrder : 1
        })
        );

    handleHeaderAction = (action) => {
        if (typeof action.handler === 'function') {
            action.handler(
                action.id,
                values(this.state.selected),
                () => this.setState({ selected: {} })
            );
        }
    };

    getSelectedStateHeader(total) {
        const { classes, config: { actions }, disableSelect } = this.props;
        const rowClass = 'h-thead ' + classes.headerRowSelected;
        const firstCellClass = `h-tcell h-thead-cell ${classes.firstCellSelectedHeader}`;
        const cellClass = `h-tcell h-thead-cell`;
        let checkboxClass = 'md-checkbox';
        const selectedLength = this.getSelectedLength();
        if (selectedLength > 0 && selectedLength < this.props.data.length) {
            checkboxClass += ' not-all';
        }
        return (
            <div className={rowClass}>
                <div className={firstCellClass}>
                    {!disableSelect && (
                        <label className={checkboxClass}>
                            <input
                                onClick={this.toggleAllSelected}
                                type='checkbox'
                                checked={this.isAllSelected()}
                            />
                            <span />
                        </label>
                    )
                    }
                    <div className='h-flexbox h-ml-13p'>
                        <span>
                            <Typography variant="overline" color={theme.palette.gray.black}>
                                {total + ' selected'}
                            </Typography>
                        </span>
                        {actions && <SVGInline className='h-ml-13p' svg={arrowRightIcon} />}
                    </div>
                </div>
                {actions && renderHeaderActions(actions, classes, this.handleHeaderAction, cellClass)}
            </div>
        );
    }

    getUnselectedStateHeader() {
        const { config, classes, disableSelect } = this.props;
        let { disableAllSelect } = this.props;
        if (!disableAllSelect) {
            disableAllSelect = false;
        }
        const firstCellClass = `h-tcell h-thead-cell ${classes.firstCell}`;
        const { sortKey, sortOrder } = this.state;
        const headerRowClass = `h-thead ${classes.headerRow}`;
        return (
            <div className={headerRowClass}>
                <div className={firstCellClass} >
                    {(!disableSelect && !disableAllSelect )&& (
                        <label className='md-checkbox'>
                            <input
                                onClick={this.toggleAllSelected}
                                type='checkbox'
                                checked={this.isAllSelected()}
                            />
                            <span />
                        </label>)
                    }
                    {/* <UserAvatar additionalClass={classes.avatar} /> */}
                </div>
                {renderHeaderCells(config.columns, classes, this.handleSort, sortKey, sortOrder)}
            </div>
        )
    }

    getHeader() {
        const selectedLength = this.getSelectedLength();
        if (selectedLength) {
            return this.getSelectedStateHeader(selectedLength);
        } else {
            return this.getUnselectedStateHeader();
        }
    }

    getEmpty() {
        const { noDataMessage } = this.props;
        return (
            <div className='h-flexbox--se h-p-8p h-flexbox--vc h-trow'>
                <span className='h-s3'><Typography variant="body2">{noDataMessage}</Typography></span>
            </div>
        );
    }
    getRows() {
        const { data, config: { columns }, classes, noAvatar, disableSelect, avatar, rowsInView } = this.props;
        if (!data || !data.length)
            return this.getEmpty();
        const { sortKey, sortOrder } = this.state;
        const cellClassName = `h-tcell h-light ${classes.firstCell}`;
        const rowClassName = `h-trow ${classes.row}`;
        const sortedData = memoizedSortTable(data, sortKey, sortOrder);
        const maxHeight = rowsInView * ROW_HEIGHT

        return (
        <FixedSizeList
        style={{
            willChange: 'none'
        }}
            itemData={{
                data:sortedData,
                rowClassName:rowClassName,
                noAvatar:noAvatar,
                cellClassName:cellClassName,
                onToggleSelected:this.toggleSelected,
                avatar:avatar,
                disableSelect:disableSelect,
                classes:classes,
                columns:columns,
                isChecked:this.isChecked,
            }}
            itemKey={(index,data) => {
                return data.data[index].id
            }}
            height={maxHeight}
            itemCount={sortedData.length}
            itemSize={ROW_HEIGHT}
            width={'auto'}
        >
            {Rows}
        </FixedSizeList>
        )
    }

    toggleAllSelected = () => {
        let { selected } = this.state;
        const { data } = this.props;
        if (!data || !data.length)
            return false;
        if (this.getSelectedLength() > 0)
            selected = {};
        else {
            data.forEach((d, i) => {
                if (!d.disableSelect)
                    selected[i] = d.id
            });
        }
        this.setState({
            selected
        }, this.onSelect);
    }

    onSelect = () => {
        const { onRowSelect } = this.props;
        typeof onRowSelect === 'function' && onRowSelect(values(this.state.selected));
    }

    toggleSelected = (e, sortedData, { id }, idx) => {
        let { selected, lastOperationIdx } = this.state;
        if (e.shiftKey) {
            const range = getIndexesInRange(idx, lastOperationIdx);
            const targetIsSelected = selected.hasOwnProperty(idx);
            //select status of all indexes in range is decided as 
            //the opposite status of the target index
            range.forEach(i => {
                if (targetIsSelected)
                    delete selected[i];
                else
                    selected[i] = sortedData[i].id;
            });
        } else {
            if (selected.hasOwnProperty(idx))
                delete selected[idx];
            else
                selected[idx] = id;
        }
        this.setState({
            selected,
            lastOperationIdx: idx
        }, this.onSelect);
    }

    render() {
        const {
            classes,
            rowsInView,
            smSubsection,
            scrollLock
        } = this.props;
        const tbodyStyle = {
            display: 'block',
            overflowY: scrollLock  === true ? 'hidden' : 'auto',
            maxHeight: rowsInView * ROW_HEIGHT
        };
        let leftPadding = '';
        if (smSubsection) {
            leftPadding = classes.smAppContainer;
        }
        return (
            <div className={`${classes.root} ${leftPadding}`}>
                <div className='h-table'>
                    {this.getHeader()}
                    <div style={tbodyStyle}>
                        {this.getRows()}
                    </div>
                </div>
            </div>
        )
    }
}
const StyledUsersTable = injectSheet(styles)(UsersTable)
StyledUsersTable.displayName = 'UsersTable'
export default StyledUsersTable;
